import { render } from "./AddressButton.vue?vue&type=template&id=87e0cc96&scoped=true"
import script from "./AddressButton.vue?vue&type=script&lang=js"
export * from "./AddressButton.vue?vue&type=script&lang=js"

import "./AddressButton.vue?vue&type=style&index=0&id=87e0cc96&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87e0cc96"]])

export default __exports__